import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import SeoHead from '../components/common/SeoHead';


import {
  MainPage,
  CleaningCartPage,
  TumblerWasherPage,
  FindPasswordPage,

  NoticeListPage,
  NoticeContentPage,

  UsageTermsPage,
  PrivacyTermsPage,
  LocationTermsPage,

  MissionCompanyPage,
  SustainabilityCompanyPage,
  LocationsCompanyPage,
  ContactUsCompanyPage,

  MobileLayout,

  SearchPage,
  LoginPage,

  DaclairPage,
  EnvReportPage,
  EnvAdPage,
  VcmPage,

  CampaignsPage,
  ManualsPage

} from '../containers'

import Footer from '../components/common/Footer';
import Header from '../components/common/Header';

export default function NonSignedRoute(props){

  const location = useLocation();
  const { pathname } = location;
  
  // 라우트 변경 시 스크롤을 맨 위로 이동
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  let type = "DESKTOP";

  if( pathname.startsWith("/mobile") ){
    type = "MOBILE";
  }

  const header = () => {
    if( type !== "MOBILE" ){
      return <Header {...props} />;
    }
    console.log(header);
    return <Header {...props} />;
  }

  const footer = () => {
    if( type !== "MOBILE" ){
      return <Footer />;
    }
    return <Footer />;
  }

  return (
    <React.Fragment>
      <SeoHead pathname={pathname} />
      {header()}
      <Routes>
        <Route path='/' element={<MainPage setToken={props.setToken} />} />
        <Route path='/products/tumblerwasher' element={<TumblerWasherPage setToken={props.setToken} />} />
        <Route path='/products/cleaningcart' element={<CleaningCartPage setToken={props.setToken} />} />
        <Route path='/contents/:id' element={<MainPage setToken={props.setToken} />} />
        <Route path='/contents' element={<MainPage setToken={props.setToken} />} />
        <Route path='/services/daclair' element={<DaclairPage />} />
        <Route path='/services/env-report' element={<EnvReportPage />} />
        <Route path='/services/env-ad' element={<EnvAdPage />} />
        <Route path='/services/vcm' element={<VcmPage />} />
        <Route path='/services/:name' element={<MainPage setToken={props.setToken} />} />
        <Route path='/notices' element={<NoticeListPage setToken={props.setToken} />} />
        <Route path='/notices/:id' element={<NoticeContentPage setToken={props.setToken} />} />
        <Route path='/docs' element={<MainPage setToken={props.setToken} />} />
        <Route path='/terms/usage' element={<UsageTermsPage setToken={props.setToken} />} />
        <Route path='/terms/privacy' element={<PrivacyTermsPage setToken={props.setToken} />} />
        <Route path='/terms/location' element={<LocationTermsPage setToken={props.setToken} />} />

        <Route path='/mobile/terms/usage' element={
          <MobileLayout>
            <UsageTermsPage setToken={props.setToken} />
          </MobileLayout>} />
        <Route path='/mobile/terms/privacy' element={
          <MobileLayout>
            <PrivacyTermsPage setToken={props.setToken} />
          </MobileLayout>} />
        <Route path='/mobile/terms/location' element={
          <MobileLayout>
            <LocationTermsPage setToken={props.setToken} />
          </MobileLayout>} />

        <Route path='/company/mission' element={<MissionCompanyPage setToken={props.setToken} />} />
        <Route path='/company/sustainability' element={<SustainabilityCompanyPage setToken={props.setToken} />} />
        <Route path='/company/locations' element={<LocationsCompanyPage setToken={props.setToken} />} />
        <Route path='/company/contact' element={<ContactUsCompanyPage setToken={props.setToken} />} />

        <Route path='/campaigns' element={<CampaignsPage />} />
        <Route path='/manuals' element={<ManualsPage />} />

        <Route path='/search' element={<SearchPage />} />
        <Route path='/login' element={<LoginPage setToken={props.setToken} />} />

        <Route path='*' element={<Navigate to="/" />} />
      </Routes>
      {footer()}
    </React.Fragment>
  );
}
